import { RequestBuilder } from "../requestBuilder";
import {
  GetMeResponseSchema,
  UpdateMeLocaleInputSchema,
  UpdateMeNameInputSchema,
  UpdateMeNameResponseSchema,
} from "./meClient.types";

export const GetMeRequestConfig = new RequestBuilder({
  path: () => "/users/me",
  responseSchema: GetMeResponseSchema,
});

// User-scoped: the server renames the row its token names, so no id travels.
export const UpdateMeNameRequestConfig = new RequestBuilder({
  path: () => "/users/me/name",
  responseSchema: UpdateMeNameResponseSchema,
  bodySchema: UpdateMeNameInputSchema,
}).withMethod("PUT");

export const UpdateMeLocaleRequestConfig = new RequestBuilder({
  path: () => "/users/me/locale",
  bodySchema: UpdateMeLocaleInputSchema,
}).withMethod("PUT");
